import React from "react";
import Nicholas from "assets/Nicholas.png";

// form & validsation
import * as yup from "yup";
import { FormError, FormRadio, FormDropDown, FormLabel } from "components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "styles";

// schema
const Step15schema = yup.object().shape({
  financial: yup.object().shape({
    if_user_struggles_debt: yup.string().required("You must provide a value"),
    if_partner_struggles_debt: yup
      .string()
      .required("You must provide a value"),
    child_support_arrangements: yup
      .string()
      .required("You must provide a value"),
  }),
});

export function Step15({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(Step15schema),
  });

  const handleData = (values) => {
    const copy_data = Object.assign({}, store.financial);
    const merger_current_values = { ...copy_data, ...values.financial };
    const mergeToStore = { ...store, financial: merger_current_values };
    onSubmit(mergeToStore);
  };
  return (
    <form id="divorce-form" onSubmit={handleSubmit(handleData)}>
      <section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`financial.if_user_struggles_debt`}
            className={customClasses.questionText}
            error={errors?.financial?.if_user_struggles_debt?.message}
          >
            Do you struggle at managing your current debt?
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="financial.if_user_struggles_debt"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="financial.if_user_struggles_debt"
              register={register}
            />
          </article>
          <FormError
            error={errors?.financial?.if_user_struggles_debt?.message}
          />
        </section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`financial.if_partner_struggles_debt`}
            className={customClasses.questionText}
            error={errors?.financial?.if_partner_struggles_debt?.message}
          >
            Do you think{" "}
            {store?.user_details?.partner_first_name
              ? store?.user_details?.partner_first_name
              : "Your Ex-Partner"}{" "}
            struggles managing their debt?
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="financial.if_partner_struggles_debt"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="financial.if_partner_struggles_debt"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="Unsure"
              name="financial.if_partner_struggles_debt"
              register={register}
            />
          </article>
          <FormError
            error={errors?.financial?.if_partner_struggles_debt?.message}
          />
        </section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`financial.child_support_arrangements`}
            className={customClasses.questionText}
            error={errors?.financial?.child_support_arrangements?.message}
          >
            What best describes your child support arrangements
          </FormLabel>
          <article>
            <FormDropDown
              placeholder="Make a selection"
              id={`financial.child_support_arrangements`}
              type="text"
              name={`financial.child_support_arrangements`}
              error={errors?.financial?.child_support_arrangements?.message}
              data={[
                `It does not apply to us`,
                `I'm paying ${
                  store?.user_details?.partner_first_name
                    ? store?.user_details?.partner_first_name
                    : "my ex-partner"
                }`,
                `${
                  store?.user_details?.partner_first_name
                    ? store?.user_details?.partner_first_name
                    : "My ex-partner"
                } is paying me`,
                `Haven't considered it`,
                `More complicated`,
              ]}
              setValue={setValue}
              register={register}
              value={watch()?.financial?.child_support_arrangements}
            />
          </article>
        </section>
      </section>
    </form>
  );
}
